import { Component, AfterViewChecked, Inject } from '@angular/core';
import { ShoppingcartService } from '../shoppingcart.service';
import { Material } from '../material';
import { Order } from '../order';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PaymentOption } from './billing-options';
import { DeliveryData } from '../typeofdelivery/delivery';
import { GoogleTagManagerService } from '../../google-tag-manager/google-tag-manager.service';

@Component({
    selector: 'pw-typeofpayment',
    templateUrl: './typeofpayment.component.html',
    styleUrls: ['./typeofpayment.component.scss']
})

//TODO backend url-ek
//TODO localhost:8083/order/create
//TODO localhost:8083/order/status
//TODO localhost:8083/order/pay
export class TypeofpaymentComponent {
    isCompany = false;
    totalQuantity = 0;
    totalPrice = 0;
    materials: Material[] = [];
    isBillAddressTheSameAsDeliveryAddress = false;
    order?: Order = {};
    contactForm?: FormGroup;
    contactFormCompany?: FormGroup;
    isSimplePay = true;
    isPayAtSite = false;
    deliveryOption = '';
    paymentOption = 'SIMPLE';
    downloadFileUrl = '';
    simplePayLogo = '';
    hasPreorder = false;

    constructor(
        private _router: Router,
        private _fb: FormBuilder,
        private _fbCompany: FormBuilder,
        private _shoppingCartService: ShoppingcartService,
        private _googleTagManagerService: GoogleTagManagerService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string
    ) {
        this.createForm();
        this.downloadFileUrl = _downloadFileUrl;
        this.simplePayLogo = this.downloadFileUrl + '/simplepaylogo';
    }

    ngOnInit(): void {
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];

        this.materials = materials;

        this.materials.filter((material) => {
            if (material.hasPreorder) {
                this.hasPreorder = true;
            }
        });

        if (materials.length === 0) {
            this._router.navigateByUrl('/');
        }

        if (sessionStorage.getItem('paymentOption')) {
            this.paymentOption = JSON.parse(sessionStorage.getItem('paymentOption') as string);
            if (this.paymentOption === 'SIMPLE') {
                this.isSimplePay = true;
                this.isPayAtSite = false;
            } else if (this.paymentOption === 'CASH') {
                this.isSimplePay = false;
                this.isPayAtSite = true;
            }
        }
        //TODO deliveryOption should come from sessionStorage
        // if (this._shoppingCartService.order) {
        //     this.deliveryOption = this._shoppingCartService.order?.deliveryData?.deliveryOption!;
        // }
        if (sessionStorage.getItem('deliveryData')) {
            const deliveryData: DeliveryData = JSON.parse(sessionStorage.getItem('deliveryData') as string) as DeliveryData;
            this.deliveryOption = deliveryData.deliveryOption!;
        }
        this.order = this._shoppingCartService.order;

        this.materials = this._shoppingCartService.getItems();
        this.isCompany = this._shoppingCartService.isCompany;
        this.calculateTotalPriceAndTotalQuantity();
        this.updateShoppingcartStatus();
    }

    calculateTotalPriceAndTotalQuantity() {
        this._shoppingCartService.calculateTotalPrice();
        this.materials.forEach((material) => {
            this.totalQuantity += material.quantity!;
            this.totalPrice += material.originalPrice! * material.quantity!;
        });
    }
    updateShoppingcartStatus() {
        this._shoppingCartService.totalPrice.subscribe((totalPrice) => (this.totalPrice = totalPrice));
        this._shoppingCartService.totalQuantity.subscribe((totalQuantity) => (this.totalQuantity = totalQuantity));
    }

    isBillingAddressTheSameAsDeliveryAddress() {
        this.isBillAddressTheSameAsDeliveryAddress = !this.isBillAddressTheSameAsDeliveryAddress;
    }
    createForm() {
        this.contactForm = this._fb.group({
            name: ['', [Validators.required, Validators.minLength(8)]],
            zipCode: ['', Validators.required],
            settlement: ['', Validators.required],
            address: ['', Validators.required]
        });

        this.contactFormCompany = this._fbCompany.group({
            name: ['', [Validators.required, Validators.minLength(8)]],
            vatNumber: ['', Validators.required],
            companyZipCode: ['', Validators.required],
            companySettlement: ['', Validators.required],
            companyAddress: ['', Validators.required]
        });
    }

    goToCartSummary() {
        if (this.isSimplePay) {
            if (this._shoppingCartService.order) {
                this._shoppingCartService.order.paymentOption = 'SIMPLE';
                sessionStorage.setItem('paymentOption', JSON.stringify(this._shoppingCartService.order.paymentOption));
            }

            this._googleTagManagerService.addPaymentInfo(this.materials, this._shoppingCartService.order?.paymentOption!);
            this._router.navigateByUrl('/cartsummary');
        } else if (this.isPayAtSite) {
            if (this._shoppingCartService.order) {
                this._shoppingCartService.order.paymentOption = 'CASH';
                sessionStorage.setItem('paymentOption', JSON.stringify(this._shoppingCartService.order.paymentOption));
            }

            this._googleTagManagerService.addPaymentInfo(this.materials, this._shoppingCartService.order?.paymentOption!);
            this._router.navigateByUrl('/cartsummary');
        }
    }

    clickOnSimplePay() {
        this.isSimplePay = true;
        this.isPayAtSite = false;
    }

    clickOnPayAtSite() {
        this.isSimplePay = false;
        this.isPayAtSite = true;
    }
}
